export default __webpack_public_path__ + "static/media/total-company.6ae7f0fe.svg";